import { IVec2 } from "../utils/vec2";

export enum SetPieceShape {
    Rectangle,
    Oval,
    Triangle,
}

export enum SetPieceColor {
    Maroon,
    Brown,
    Teal,
    Navy,
    Green,
    Purple,
    Grey,
}

export interface ISetPiece {
    id: number;
    name: string;
    shape: SetPieceShape;
    color: SetPieceColor;
    pos: IVec2;
    size: IVec2;
    rotation: number;
}

export interface IAudience {
    height: number;
    pos: IVec2;
    rotation: number; // North is 0 and goes clockwise
}

export interface ISetPieces {
    audience: IAudience;
    setPieces: ISetPiece[];
    nextSetPieceId: number;
    selectedSetPieceId: number | "audience";
}